<div class="actions-container">
  <ignite-panel-menu [menuOptions]="menuOptions"></ignite-panel-menu>
</div>
